import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=530647b0&scoped=true&"
import script from "./Resource.vue?vue&type=script&lang=js&"
export * from "./Resource.vue?vue&type=script&lang=js&"
import style0 from "./Resource.vue?vue&type=style&index=0&id=530647b0&lang=scss&scoped=true&"
import style1 from "./Resource.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530647b0",
  null
  
)

export default component.exports